import { Injectable, OnDestroy } from '@angular/core';
import { FeaturePermission } from '@app/shared/services/api/permission.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExterneAppsStateService } from './externe-apps-state.service';
import { ExterneAppsIconStateService } from './externe-apps-icon-state.service';
import { GenericAppFormIconProps } from '@app/shared/models/generic-app';
import { ExterneAppFeatureService } from './externe-app-feature.service';
import { MunicipalityManagementQueueStateService } from './municipality-management-queue-state.service';
import { PermissionStatus } from '../models/externe-apps';

@Injectable({
  providedIn: 'root',
})
export class ExterneAppsFacadeService implements OnDestroy {
  public featurePermissions$: Observable<FeaturePermission[]>;
  public featurePermissionStateIsLoading$: Observable<boolean>;
  public featureIcons$: Observable<[GenericAppFormIconProps[], GenericAppFormIconProps[]]>;
  public savingError$: BehaviorSubject<boolean> = this.externeAppFeatureService.savingError$;

  constructor(
    private externeAppFeatureService: ExterneAppFeatureService,
    private externeAppsStateService: ExterneAppsStateService,
    private externeAppsIconStateService: ExterneAppsIconStateService,
    private municipalityManagementQueueStateService: MunicipalityManagementQueueStateService
  ) {
    this.featurePermissionStateIsLoading$ = this.externeAppsStateService.featurePermissionStateIsLoading$;
    this.featurePermissions$ = this.externeAppsStateService.featurePermissions$;
    this.featureIcons$ = this.externeAppsIconStateService.featureIcons$;
  }

  public ngOnDestroy(): void {
    this.externeAppsStateService.ngOnDestroy();
    this.externeAppsIconStateService.ngOnDestroy();
  }

  public externeAppsDispatch(municipalityGuid?: string): void {
    this.externeAppsStateService.dispatch(municipalityGuid);
  }

  public addExterneApp(): void {
    this.externeAppFeatureService.addExterneApp();
  }

  public editExterneApp(feature: FeaturePermission): void {
    this.externeAppFeatureService.editExterneApp(feature);
  }

  public deleteExterneApp(feature: FeaturePermission): void {
    this.externeAppFeatureService.deleteExterneApp(feature);
  }

  public externeAppsIconDispatch(): void {
    this.externeAppsIconStateService.dispatch();
  }

  public updateExterneLink(permissionID: string, externalLink: string): void {
    this.externeAppsStateService.updateIndividualLink(permissionID, externalLink);
  }

  public clearQueueStateService(): void {
    this.municipalityManagementQueueStateService.clear();
  }

  public applyIndividualLinks(municipalityId: string): Observable<any> {
    return this.externeAppFeatureService.applyIndividualLinks(municipalityId);
  }

  public updateExterneAppStatus(externeAppStatus: PermissionStatus[], isGenericLink: boolean, hasLink: boolean): PermissionStatus[] {
    return this.externeAppsStateService.mapDefaultStatus(externeAppStatus, isGenericLink, hasLink);
  }
}
